<template>
  <section class="section">
    <div class="container">
      <div class="box">
        <h1 class="title is-4">Payer Outage</h1>
        <b-field>
          <b-input v-model="search" placeholder="Search by payer name" icon="magnify" />
        </b-field>

        <b-table
          :data="filteredOutages"
          :loading="loading"
          striped
          hoverable
          paginated
          per-page="15"
        >
          <b-table-column field="payer_name" label="Payer" v-slot="props" sortable>
            {{ props.row.payer_name }}
          </b-table-column>
          <b-table-column field="status" label="Status" v-slot="props" sortable>
            <b-tag :type="statusClass(props.row.status)">{{ props.row.status }}</b-tag>
          </b-table-column>
          <template #empty>
            <div class="has-text-centered has-text-grey p-4">
              {{ emptyMessage }}
            </div>
          </template>
        </b-table>
      </div>
    </div>
  </section>
</template>

<script>
import request from '../request';

export default {
  name: 'PayerOutageList',
  data() {
    return {
      outages: [],
      loading: false,
      search: '',
    };
  },
  computed: {
    filteredOutages() {
      const query = this.search.trim().toLowerCase();
      if (!query) return this.outages;
      return this.outages.filter(
        (payer) =>
          (payer.payer_name || '').toLowerCase().includes(query));
    },
    emptyMessage() {
      if (this.loading) return 'Loading payer outages…';
      if (this.search.trim()) return 'No payers match the current filter.';
      return 'No payer outages right now.';
    },
  },
  created() {
    this.fetchOutages();
  },
  methods: {
    async fetchOutages() {
      this.loading = true;
      try {
        const response = await request.get('/payers/outages');
        this.outages = response.data.payer_outages || [];
      } catch {
        this.$buefy.toast.open({ message: 'Failed to load payer outages.', type: 'is-danger' });
      } finally {
        this.loading = false;
      }
    },
    statusClass(status) {
      return {
        high: 'is-danger',
        medium: 'is-warning',
        low: 'is-info',
      }[(status || '').trim().toLowerCase()] || 'is-light';
    },
  },
};
</script>
